module.exports = __webpack_public_path__ + "img/2.9e333994.png";